import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: null,
  user: null,
  resetPasswordEmail: "",

  columnForDetail: {},
  columnForDetailWidth: {},
  summaryBarFields: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    authFailed: state => {
      state.isAuthenticated = false;
      state.user = null;
    },
    authSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload;
    },
    isPasswordCreated: state => {
      state.user = { ...state.user, has_password: true };
    },
    logOut: state => {
      state.isAuthenticated = false;
      state.user = null;
    },
    setDefaultPreferences: (state, action) => {
      const {
        column_for_detail = {},
        column_for_detail_width = {},
        summary_bar_fields = {},
      } = action.payload || {};

      if (typeof column_for_detail === "object" && column_for_detail !== null) {
        state.columnForDetail = column_for_detail;
      }

      if (typeof column_for_detail_width === "object" && column_for_detail_width !== null) {
        state.columnForDetailWidth = column_for_detail_width;
      }

      if (typeof summary_bar_fields === "object" && summary_bar_fields !== null) {
        state.summaryBarFields = summary_bar_fields;
      }
    },
    updateColumnForDetail: (state, action) => {
      const { module, column_for_detail } = action.payload;
      state.columnForDetail = {
        ...state.columnForDetail,
        [module]: column_for_detail,
      };
    },
    updateColumnForDetailWidth: (state, action) => {
      const { module, column_for_detail_width } = action.payload;
      state.columnForDetailWidth = {
        ...state.columnForDetailWidth,
        [module]: {
          ...(state.columnForDetailWidth[module] || {}),
          ...column_for_detail_width,
        },
      };
    },
    updateSummaryBarFields: (state, action) => {
      const { module, summary_bar_fields } = action.payload;
      state.summaryBarFields = {
        ...state.summaryBarFields,
        [module]: summary_bar_fields,
      };
    },
    clearSummaryBarFields: (state, action) => {
      const { module } = action.payload;
      const next = { ...state.summaryBarFields };
      delete next[module];
      state.summaryBarFields = next;
    },
    updatePerPageParams: (state, action) => {
      const { limit, precision } = action.payload;
      state.user = { ...state.user, limit: limit, precision: precision };
    },
    addEmailInResetPassword: (state, action) => {
      state.resetPasswordEmail = action.payload;
    },
    updateAuthUserProfile: (state, action) => {
      const { avatar_key, first_name, full_name, last_name, phone, profile_photo } =
        action.payload || {};
      state.user = {
        ...state.user,
        ...(avatar_key !== undefined && { avatar_key }),
        ...(first_name !== undefined && { first_name }),
        ...(full_name !== undefined && { full_name }),
        ...(last_name !== undefined && { last_name }),
        ...(phone !== undefined && { phone }),
        ...(profile_photo !== undefined && { profile_photo }),
      };
    },
  },
});

export const {
  authFailed,
  authSuccess,
  isPasswordCreated,
  logOut,
  setDefaultPreferences,
  updateColumnForDetail,
  updateColumnForDetailWidth,
  updateSummaryBarFields,
  clearSummaryBarFields,
  updatePerPageParams,
  addEmailInResetPassword,
  updateAuthUserProfile,
} = authSlice.actions;

export default authSlice.reducer;

export const authUser = state => state.auth.user;
export const isAuthenticated = state => state.auth.isAuthenticated;
